import React from "react";

const linkStyleDefault = {
  color: '#4183c4',
}

/** 
 * Allow user to order a post sale inspection
 * @param {{isChecked: boolean, onAgreeChange: ()=>void, linkStyle?: React.CSSProperties}} props
 * @returns {React.JSX} 
 */
function OrderPostSaleInspection ({isChecked, onAgreeChange, linkStyle=linkStyleDefault}) {
    
    return (
      <div className='form-group'>
        <input
          type="checkbox"
          id="psi-agree"
          checked={isChecked}
          onChange={onAgreeChange}
        />
        <label htmlFor="psi-agree" style={{ marginLeft: 5, color: '#787878' }}>
            Order a post sale inspection
        </label>
      </div>
    )
    
}

export {OrderPostSaleInspection};